import React from 'react';
import withWrapper from '../withWrapper';
export default withWrapper('Loading', function (props) {
  return React.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("g", {
    stroke: props.outStrokeColor,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, React.createElement("path", {
    d: "M11.932 2.4v3.813"
  }, React.createElement("animate", {
    attributeType: "CSS",
    attributeName: "opacity",
    values: "1;0",
    begin: "-1s",
    dur: "1s",
    repeatCount: "indefinite"
  })), React.createElement("path", {
    d: "M15.973 7.89l2.698-2.697"
  }, React.createElement("animate", {
    attributeType: "CSS",
    attributeName: "opacity",
    values: "1;0",
    begin: "-0.852s",
    dur: "1s",
    repeatCount: "indefinite"
  })), React.createElement("path", {
    d: "M17.651 11.932h3.813"
  }, React.createElement("animate", {
    attributeType: "CSS",
    attributeName: "opacity",
    values: "1;0",
    begin: "-0.71s",
    dur: "1s",
    repeatCount: "indefinite"
  })), React.createElement("path", {
    d: "M15.973 15.974l2.698 2.697"
  }, React.createElement("animate", {
    attributeType: "CSS",
    attributeName: "opacity",
    values: "1;0",
    begin: "-0.548s",
    dur: "1s",
    repeatCount: "indefinite"
  })), React.createElement("path", {
    d: "M11.932 17.65v3.814"
  }, React.createElement("animate", {
    attributeType: "CSS",
    attributeName: "opacity",
    values: "1;0",
    begin: "-0.426s",
    dur: "1s",
    repeatCount: "indefinite"
  })), React.createElement("path", {
    d: "M5.193 18.671l2.697-2.697"
  }, React.createElement("animate", {
    attributeType: "CSS",
    attributeName: "opacity",
    values: "1;0",
    begin: "-0.284s",
    dur: "1s",
    repeatCount: "indefinite"
  })), React.createElement("path", {
    d: "M2.4 11.932h3.813"
  }, React.createElement("animate", {
    attributeType: "CSS",
    attributeName: "opacity",
    values: "1;0",
    begin: "-0.142s",
    dur: "1s",
    repeatCount: "indefinite"
  })), React.createElement("path", {
    d: "M5.193 5.193L7.89 7.89"
  }, React.createElement("animate", {
    attributeType: "CSS",
    attributeName: "opacity",
    values: "1;0",
    begin: "0s",
    dur: "1s",
    repeatCount: "indefinite"
  }))));
});